import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/my_company_members/Details.scss';
import * as _ from 'lodash';
import { withRouter } from 'react-router';
import autobind from 'autobind-decorator';
import { __, mapStateToProps, validateForm } from '../../core/utils';
import { setNotification } from '../../redux/actions/general/notification';
import { updateCompanyMemberDetails } from '../../redux/actions/table/my_company_members';
import DetailsForm from '../../forms/my_company_members/DetailsForm';
import classNames from 'classnames';
import Localization from '../../helpers/Localization';
import { subscribe } from 'react-contextual/dist/react-contextual.es';

@withRouter
@mapStateToProps((state) => ({
  table: state.table['my_company_members'],
  auth: state.auth,
}))
@subscribe(Localization, 'localization')
class Details extends Component {
  @autobind
  _handleSubmit(formData) {
    const {
      flyout: { compensation },
    } = this.props.table;

    formData = {
      ...formData,
    };

    return validateForm(
      updateCompanyMemberDetails(formData).then(() => {
        this.props.readAction();
        setNotification(__('my-company-members.properties.saved'));
      })
    );
  }

  render() {
    const { data, collapsed, localization } = this.props;

    return (
      <div
        className={classNames(styles.wrapper, collapsed && styles.collapsed)}
      >
        <DetailsForm
          onSubmit={this._handleSubmit}
          data={data}
          localization={localization}
          initialValues={{
            user_id: data.details.id,
            employee_id: data.details?.employee_id,
            title: data.details?.title,
            firstname: data.details?.firstname,
            middlename: data.details?.middlename,
            lastname: data.details?.lastname,
            phone_number: data.details?.phone_number,
            email: data.details?.email,
            work_vpn: data.details?.work_vpn,
            disciplines: data.details?.disciplines,
          }}
        />
      </div>
    );
  }
}

export default Details;
